// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#notification-navbar{list-style-type:none}#notification-navbar a.btn.btn-primary{display:none}@media (min-width:992px){#notification-navbar{position:fixed;width:100%;z-index:1003}}", ""]);
// Exports
module.exports = exports;
